
import { default as app } from '@legacy/App';
import { environment } from 'src/environments/environment';


app.factory('LoginFactory', ['$http', 'settings', 'masterFactory', function ($http, settings, masterFactory) {
    return {
        validateUser: function (user) {
            return $http.get(settings.ApiURL + settings.MasterDataURL + '/validateuser/' + user.username + '/' + encodeURIComponent(user.password));
        },
        authenticate: function (user) {

            var config = {
                method: 'POST',
                url: environment.endpoint.server + '/token',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: 'grant_type=password&username=' + user.username + '&password=' + encodeURIComponent(user.password) + '&company=' + user.company,
            };
            var setHttpAuthHeader = function (bearerToken) {
                sessionStorage.setItem("Bearer", bearerToken);
                return $http.defaults.headers.common.Authorization = 'Bearer ' + bearerToken;
            };

            return $http(config)
                .success(function (data) {
                    setHttpAuthHeader(data.access_token);
                })
                .error(function (data) {
                    return data;
                });
        }
    }
}]);

app.controller('LoginController', function ($scope, $state, LoginFactory, $rootScope, settings, masterFactory) {
    // Initialization - this runs on load
    var init = function () {
        $rootScope.pageTitle = "Login";
        $scope.error = "";
        $scope.isFormVisible = false;
        $scope.user = {
            username: '',
            password: ''
        };

        // Notify the user to upgrade the browser to HTML5 enable browser.
        if (typeof (Storage) == "undefined") {
            alert("Your browser does not support HTML5. Try upgrading.");
        }
    };

    init();

    $scope.cancelForm = function () {
        $scope.loginForm.submitted = false;
    }

    $scope.submitForm = function () {
        if ($scope.loginForm.$valid) {
            $scope.submitLogin();
            $scope.loginForm.submitted = false;
        } else {
            $scope.loginForm.submitted = true;
        }
    };

    $scope.submitLogin = function () {
        $scope.closeAlert();
        $('#loadingModal').modal({ backdrop: 'static' });
        LoginFactory.authenticate($scope.user).success(function (data) {
            $rootScope.user.isAuthenticated = true;
            masterFactory.getUserLoginInfo();
            masterFactory.RefreshDbIcon();
            masterFactory.getModulesStatus();
            $state.go('home');
        }).error(function (data) {
            if (data)
                $scope.error = data.error_description;
            else {
                $scope.error = 'network error';
            }
        }).finally(function () {
            $('#loadingModal').modal('hide');
        });
    };

    // Helping functions and events
    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.closeAlert = function () {
        $scope.error = null;
    };

});